import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, siteConfig } from '@/mocks/siteData';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10, 14);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || submitting) return;
    setSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      await fetch('https://readdy.ai/api/form/d8sl4l5e8ise6dlc8tog', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[40%]">
            <h3 className="text-2xl font-heading font-semibold text-foreground-950 mb-3">
              {siteConfig.siteName}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-md">
              An independent educational resource about mulebuy spreadsheet systems. We provide guides, comparisons, and safety analysis to help you make informed shopping decisions. We do not operate any mulebuy spreadsheet service or handle payments.
            </p>

            <form
              data-readdy-form
              id="newsletter-footer"
              onSubmit={handleSubmit}
              className="max-w-sm"
            >
              <label htmlFor="footer-email" className="block text-sm font-medium text-foreground-700 mb-2">
                Subscribe for Updates
              </label>
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  id="footer-email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="flex-1 px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  required
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="px-5 py-2.5 text-sm bg-primary-500 text-background-50 rounded-md font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  {submitting ? 'Sending...' : 'Subscribe'}
                </button>
              </div>
              {submitted && (
                <p className="text-xs text-accent-600 mt-2">Thanks for subscribing!</p>
              )}
            </form>
          </div>

          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">Category One</h4>
              <div className="flex flex-col gap-2">
                {col1.map((cat) => (
                  <a
                    key={cat.seq}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">Category Two</h4>
              <div className="flex flex-col gap-2">
                {col2.map((cat) => (
                  <a
                    key={cat.seq}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">More</h4>
              <div className="flex flex-col gap-2">
                {col3.map((cat) => (
                  <a
                    key={cat.seq}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
                <Link
                  to="/mulebuy-spreadsheet-complete-guide"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer mt-2"
                >
                  Complete Guide
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.siteName}. All rights reserved. This is an independent educational resource.
          </p>
          <p className="text-xs text-foreground-400">
            Always verify third-party services before making transactions.
          </p>
        </div>
      </div>
    </footer>
  );
}